import { useTimerTick } from '../hooks/useTimerTick';
import type { TimerDisplayProps } from '../types';

function formatElapsed(seconds: number): string {
  if (seconds < 3600) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}m ${s}s`;
  }
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return `${h}h ${m}m`;
}

export function TimerDisplay({ startTime, className }: TimerDisplayProps) {
  const elapsed = useTimerTick(startTime);
  return (
    <span data-testid="time-tracking-timer-display" className={className}>
      {formatElapsed(elapsed)}
    </span>
  );
}
